import gql from "@/api/gql.js"
import { query, mutation } from "./queries.js"
import resolveApiErrors from "@/api/resolveApiErrors"

export default {
	async organization(variables) {
		const res = await gql({
			query: query.organization,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "organizations"
		})
	},

	async organizations(variables) {
		const res = await gql({
			query: query.organizations,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "organizations"
		})
	},

	async createOrganization(variables) {
		const res = await gql({
			query: mutation.createOrganization,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "createOrganization"
		})
	},

	async updateOrganization(variables) {
		const res = await gql({
			query: mutation.updateOrganization,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateOrganization"
		})
	},

	async deleteOrganization(variables) {
		const res = await gql({
			query: mutation.deleteOrganization,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "deleteEntity"
		})
	}
}
